import "./style.scss";

const mbody = document.body;
const mhtml = document.documentElement;

const mheader = document.getElementById("masthead");
const mfooter = document.getElementById("colophon");

// get header section height
const headerHeight = mheader.getBoundingClientRect().height;

//console.log(headerHeight);


// on scroll add class to body
window.addEventListener("scroll", () => {
    mbody.classList.toggle("scrolling", window.scrollY > headerHeight);
});